import type { ChatPlugin } from '#types/plugin/chat'
import enhancedLiveChat from '#core/integrations/enhanced-live-chat'
import sierraChat from '#core/integrations/sierra-chat'
import { languageConfig } from '../../../../config/integrations/livechat'

export default defineNuxtPlugin<{ chat: ChatPlugin }>(() => {
  const { configLivechat, enableChat } = useFeatureFlags()
  const locale = useLocale()

  if (!enableChat) {
    return {
      provide: {
        chat: {
          open: () => console.warn('Chat is disabled by feature flag'),
          available: ref(false)
        }
      }
    }
  }

  // Certain regions in EMEA will use Sierra
  if (configLivechat.enabled && configLivechat.sierraRegions?.includes(locale))
    return sierraChat({ hideLauncher: true })

  if (configLivechat.enabled) {
    return enhancedLiveChat({
      brand: 'Vans',
      languageConfig,
      cssPath: '/livechat/css/LiveChatCodeCanvasVansEMEA.css',
    })
  }

  // No other chat provider for Vans
  return {
    provide: {
      chat: {
        open: () => console.warn('Chat is not implemented for Vans EMEA.'),
        available: ref(false)
      }
    }
  }
})
